export default "__VITE_ASSET__B_kW4wpK__"